import { ValueOf } from 'modules/Monitoring/types'

export const UrlSearchParam = {
  From: 'from',
  To: 'to',
  Start: 'start',
  End: 'end',
  Queue: 'queue',
  Agent: 'agent',
  Specialisation: 'specialisation',
  Departments: 'departments',
  Channel: 'channel',
  Region: 'region',
} as const

export type UrlSearchParam = ValueOf<typeof UrlSearchParam>
